import React from 'react'

function TotalMsbCommmissionReport() {
  return (
    <div>TotalMsbCommmissionReport</div>
  )
}

export default TotalMsbCommmissionReport